import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';

const socket = io('https://food-server-5s14.onrender.com'); // SERVER IP

function App() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    socket.on('items', (data) => {
      setItems(data);
    });

    return () => socket.off('items');
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>PC2: View Items</h2>
      {items.map((item, idx) => (
        <div key={idx} style={{ marginBottom: 20 }}>
          <p><strong>{item.text}</strong></p>
          <img src={item.image} alt="uploaded" width="300" />
        </div>
      ))}
    </div>
  );
}

export default App;